export default {
    en: {
        messages: {
             //required: 'Please do not leave this blank'
			 min: (value, min) => 'Please ensure you enter more than ' + min + ' characters',
			 max: (value, max) => 'Please ensure you enter less than ' + max + ' characters'
         },
        custom: {
            /**
             * Register page
             */
            honorific_id: {
                required: 'Please provide your title'
            },
            first_name: {
                required: 'Please provide your first name'
            },
            last_name: {
                required: 'Please provide your last name'
            },
            email_address: {
                required: 'You must provide a valid email address',
                email: 'Please ensure the email you entered is valid',
                confirmed: 'Please confirm your email address'
            },
            password_clear: {
                required: 'Plese enter a strong password',
                confirmed: 'Please confirm your password',
                min: 'The password must be at least 8 characters',
                max: 'The password must not exceed 20 characters',
            },
            traffic_source_id: {
                required: 'It would be nice to know how you found us, please choose an option from the above'
            },
            mobile: {
                required: 'Please provide a mobile number to contact you on'
            },
            day_telephone: {
                required: 'Please provide a secondary number we can contact you on'
            },
            child_relationship: {
                required: 'Please provide your relationship with the child'
            },
            postcode: {
                required: 'Please provide a valid postcode'
            },
            address_line_1: {
                required: 'Please provide a valid address line'
            },
            address_line_2: {
                required: 'Please provide a valid secondary address line'
            },
            town: {
                required: 'Please provide a valid town'
            },
            county: {
                required: 'Please provide a valid county'
            },
            us_state_id: {
                required: 'Please provide a valid US state'
            },
            country_id: {
                required: 'Please provide a valid country'
            },

            /**
             * Login
             */
            email: {
                required: 'Please enter your email',
            },
            password: {
                required: 'Please enter your password',
            },

            /**
             * New Participant
             */
            firstname: {
                required: 'Please enter the child\'s first name'
            },
            lastname: {
                required: 'Please enter the child\'s last name'
            },
            dateofbirth: {
                valid_date: 'Please provide a valid date of birth',
                allowed_age: 'Child is either too old or too young for this package, please call us on 0114 263 2160 for help booking'
            },

            /**
             * Quick add | Quick edit
             */
            dates_available: {
                required: 'Please select the week the child will be attending'
            },
            bases_available: {
                required: 'Please select the programme you would like your child to attend'
            },

            /**
             * Confirm payment
             */
            confirmPayment: {
                required: 'You must accept the terms & conditions to proceed with your booking'
            },

            /**
             * Participant complete form
             */
            gender_id: {
                required: 'Please provide the gender of the child',
            },
            other_gender: {
                required: 'Please provide the gender of the child',
            },
            dob: {
                required: 'Please provide the child\'s date of birth'
            },
            school_id: {
                required: 'Either a UK School or Non-UK School should be provided',
            },
            swimming_ability_id: {
                required: 'Please provide the appropriate swimming ability for your child'
            },
            tshirt_size_id: {
                required: 'Please provide the size t-shirt your child will need'
            },
            emergency_contact: {
                required: 'We require you to provide an emergency contact'
            },
            has_behaviour_issues: {
                required: 'Please confirm if there are any behaviour details that should be noted'
            },
            behaviour_issue_details: {
                required: 'Please provide details about the child\'s behaviour'
            },
            parents_support_question: {
                required: 'Please confirm if your child needs additional support'
            },
            parents_support_notes: {
                required: 'Please provide details about the support required'
            },
            important_information: {
                required: 'Please read the information carefully'
            },
            needs_assistance: {
                required: 'Please provide whether your child needs assistance in any way',
            },
            assistance_details: {
                required: 'No details about assistance provided',
            },
            has_medicial_issues: {
                required: 'Please provide whether your child has any medical issues',
            },
            medical_issue_details: {
                required: 'Please let us know what medical issues your child has',
            },
            has_anaphylaxsis: {
                required: 'You must let us know whether your child has anaphylaxsis'
            },
            has_anaphylaxsis_agreement: {
                required: 'We require an agreement if the participant has anaphylaxsis',
            },
            has_allergies: {
                required: 'Please confirm if your child has any allergies'
            },
            allergy_details: {
                required: 'Please outline allergy details if your child has any allergies'
            },
            has_treatment_permission: {
                required: 'We require permission to be able to treat your child in an accident'
            },
            treatment_exceptions: {
                required: 'You have stated there are exceptions to how we can treat your child, please explain'
            },
            doctor_details: {
                required: 'Please give the name of any doctor that your child attends',
            },
            camp_notes: {
                required: 'Please make additional notes you would like our staff to be aware of.'
            },
            has_swimming_session_permission: {
                required: 'Does your child have permission to join in swimming sessions?'
            },
            has_promotional_photography_permission: {
                required: 'Does your child have permission to join in photography sessions?'
            },
            has_return_home_unaccompanied_permission: {
                required: 'Does your child have permission to return home unaccompanied?'
            },
            has_given_consent: {
                required: 'You must give your consent',
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/languages/en-gb-validation.js